import classNames from "classnames";
import "./index.scss";

interface IProps {
  color?: string;
  size?: number;
  isExpanded?: boolean;
  style?: string;
  onClick?: () => void;
}

export const AlternateSessionsChevronIcon = ({
  color = "#3272be",
  size = 16,
  isExpanded = false,
  style,
  onClick,
}: IProps) => {
  return (
    <div
      className={classNames("alternate-sessions-chevron-icon", {
        expanded: isExpanded,
        [`${style}`]: style,
      })}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M4 6L8 10L12 6"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
